module.exports = __webpack_public_path__ + "img/logo_quantique.47be187f.png";